module.exports = __webpack_public_path__ + "img/Comic_60.119ed82c.png";